// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicSplatRouteImport } from './routes/_public/$'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicBeatMyEstimateRouteImport } from './routes/_public/beat-my-estimate'
import { Route as PublicBookRouteImport } from './routes/_public/book'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicCookiesRouteImport } from './routes/_public/cookies'
import { Route as PublicFenceTuneupRouteImport } from './routes/_public/fence-tuneup'
import { Route as PublicFinancingRouteImport } from './routes/_public/financing'
import { Route as PublicFranchiseOpportunitiesRouteImport } from './routes/_public/franchise-opportunities'
import { Route as PublicGalleryRouteImport } from './routes/_public/gallery'
import { Route as PublicNeighborsRouteImport } from './routes/_public/neighbors'
import { Route as PublicPrivacyRouteImport } from './routes/_public/privacy'
import { Route as PublicReferRouteImport } from './routes/_public/refer'
import { Route as PublicRestorationPreviewRouteImport } from './routes/_public/restoration-preview'
import { Route as PublicShareYourFenceRouteImport } from './routes/_public/share-your-fence'
import { Route as PublicTermsRouteImport } from './routes/_public/terms'
import { Route as PublicThanksRouteImport } from './routes/_public/thanks'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountMaintenanceRouteImport } from './routes/account/maintenance'
import { Route as AccountOrdersRouteImport } from './routes/account/orders'
import { Route as AccountReferralsRouteImport } from './routes/account/referrals'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAdDirectorRouteImport } from './routes/admin/ad-director'
import { Route as AdminAdStudioRouteImport } from './routes/admin/ad-studio'
import { Route as AdminAppointmentsRouteImport } from './routes/admin/appointments'
import { Route as AdminAttributionRouteImport } from './routes/admin/attribution'
import { Route as AdminAudienceLabRouteImport } from './routes/admin/audience-lab'
import { Route as AdminCartLinkRouteImport } from './routes/admin/cart-link'
import { Route as AdminCheckoutAttemptsRouteImport } from './routes/admin/checkout-attempts'
import { Route as AdminDraftsRouteImport } from './routes/admin/drafts'
import { Route as AdminEmailHealthRouteImport } from './routes/admin/email-health'
import { Route as AdminEmailLogRouteImport } from './routes/admin/email-log'
import { Route as AdminExperimentsRouteImport } from './routes/admin/experiments'
import { Route as AdminFranchiseLeadsRouteImport } from './routes/admin/franchise-leads'
import { Route as AdminIndexingRouteImport } from './routes/admin/indexing'
import { Route as AdminLengthSettingsRouteImport } from './routes/admin/length-settings'
import { Route as AdminLocationContentRouteImport } from './routes/admin/location-content'
import { Route as AdminLocationHeroVideoRouteImport } from './routes/admin/location-hero-video'
import { Route as AdminLocationHeroesRouteImport } from './routes/admin/location-heroes'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminMaintenanceRouteImport } from './routes/admin/maintenance'
import { Route as AdminMarketingAiRouteImport } from './routes/admin/marketing-ai'
import { Route as AdminPageLayoutsRouteImport } from './routes/admin/page-layouts'
import { Route as AdminPromoCodesRouteImport } from './routes/admin/promo-codes'
import { Route as AdminReferralsRouteImport } from './routes/admin/referrals'
import { Route as AdminResetPasswordRouteImport } from './routes/admin/reset-password'
import { Route as AdminRestorationPreviewsRouteImport } from './routes/admin/restoration-previews'
import { Route as AdminStateRulesRouteImport } from './routes/admin/state-rules'
import { Route as PublisherIndexRouteImport } from './routes/publisher/index'
import { Route as PublisherIdRouteImport } from './routes/publisher/$id'
import { Route as PublisherLoginRouteImport } from './routes/publisher/login'
import { Route as PublisherNewRouteImport } from './routes/publisher/new'
import { Route as PublisherSetPasswordRouteImport } from './routes/publisher/set-password'
import { Route as PublicFranchiseStateRouteImport } from './routes/_public/franchise/$state'
import { Route as PublicFranchiseWashingtonRouteImport } from './routes/_public/franchise/washington'
import { Route as PublicLearnIndexRouteImport } from './routes/_public/learn/index'
import { Route as PublicLearnSlugRouteImport } from './routes/_public/learn/$slug'
import { Route as PublicLocationsIndexRouteImport } from './routes/_public/locations/index'
import { Route as PublicLocationsSlugRouteImport } from './routes/_public/locations/$slug'
import { Route as PublicOrderIndexRouteImport } from './routes/_public/order/index'
import { Route as PublicOrderSuccessRouteImport } from './routes/_public/order/success'
import { Route as PublicPayBalanceTokenRouteImport } from './routes/_public/pay-balance/$token'
import { Route as PublicServicesDeerFenceRouteImport } from './routes/_public/services/deer-fence'
import { Route as PublicServicesDogFenceRouteImport } from './routes/_public/services/dog-fence'
import { Route as PublicServicesFenceRestorationRouteImport } from './routes/_public/services/fence-restoration'
import { Route as PublicServicesGardenFenceRouteImport } from './routes/_public/services/garden-fence'
import { Route as AdminContentIndexRouteImport } from './routes/admin/content/index'
import { Route as AdminContentIdRouteImport } from './routes/admin/content/$id'
import { Route as AdminContentNewRouteImport } from './routes/admin/content/new'
import { Route as AdminLeadsIndexRouteImport } from './routes/admin/leads/index'
import { Route as AdminMediaSubmissionsIndexRouteImport } from './routes/admin/media-submissions/index'
import { Route as AdminMediaSubmissionsIdRouteImport } from './routes/admin/media-submissions/$id'
import { Route as AdminOrdersIndexRouteImport } from './routes/admin/orders/index'
import { Route as AdminOrdersIdRouteImport } from './routes/admin/orders/$id'
import { Route as AdminPhotosIndexRouteImport } from './routes/admin/photos/index'
import { Route as AdminPhotosDuplicatesRouteImport } from './routes/admin/photos/duplicates'
import { Route as AdminPhotosLibraryRouteImport } from './routes/admin/photos/library'
import { Route as PublicLocationsABRouteImport } from './routes/_public/locations/$a.$b'
import { Route as AdminLeadsKindIdRouteImport } from './routes/admin/leads/$kind.$id'
import { Route as AdminPhotosReviewIndexRouteImport } from './routes/admin/photos/review/index'
import { Route as AdminPhotosReviewIdRouteImport } from './routes/admin/photos/review/$id'
import { Route as PublicLocationsStateSlugTownSlugServiceSlugRouteImport } from './routes/_public/locations/$stateSlug.$townSlug.$serviceSlug'

const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicSplatRoute = PublicSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => PublicRoute
          })
const PublicAboutRoute = PublicAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => PublicRoute
          })
const PublicBeatMyEstimateRoute = PublicBeatMyEstimateRouteImport.update({
            id: '/beat-my-estimate',path: '/beat-my-estimate',getParentRoute: () => PublicRoute
          })
const PublicBookRoute = PublicBookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => PublicRoute
          })
const PublicContactRoute = PublicContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => PublicRoute
          })
const PublicCookiesRoute = PublicCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => PublicRoute
          })
const PublicFenceTuneupRoute = PublicFenceTuneupRouteImport.update({
            id: '/fence-tuneup',path: '/fence-tuneup',getParentRoute: () => PublicRoute
          })
const PublicFinancingRoute = PublicFinancingRouteImport.update({
            id: '/financing',path: '/financing',getParentRoute: () => PublicRoute
          })
const PublicFranchiseOpportunitiesRoute = PublicFranchiseOpportunitiesRouteImport.update({
            id: '/franchise-opportunities',path: '/franchise-opportunities',getParentRoute: () => PublicRoute
          })
const PublicGalleryRoute = PublicGalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => PublicRoute
          })
const PublicNeighborsRoute = PublicNeighborsRouteImport.update({
            id: '/neighbors',path: '/neighbors',getParentRoute: () => PublicRoute
          })
const PublicPrivacyRoute = PublicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => PublicRoute
          })
const PublicReferRoute = PublicReferRouteImport.update({
            id: '/refer',path: '/refer',getParentRoute: () => PublicRoute
          })
const PublicRestorationPreviewRoute = PublicRestorationPreviewRouteImport.update({
            id: '/restoration-preview',path: '/restoration-preview',getParentRoute: () => PublicRoute
          })
const PublicShareYourFenceRoute = PublicShareYourFenceRouteImport.update({
            id: '/share-your-fence',path: '/share-your-fence',getParentRoute: () => PublicRoute
          })
const PublicTermsRoute = PublicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => PublicRoute
          })
const PublicThanksRoute = PublicThanksRouteImport.update({
            id: '/thanks',path: '/thanks',getParentRoute: () => PublicRoute
          })
const AccountIndexRoute = AccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => rootRouteImport
          })
const AccountMaintenanceRoute = AccountMaintenanceRouteImport.update({
            id: '/account/maintenance',path: '/account/maintenance',getParentRoute: () => rootRouteImport
          })
const AccountOrdersRoute = AccountOrdersRouteImport.update({
            id: '/account/orders',path: '/account/orders',getParentRoute: () => rootRouteImport
          })
const AccountReferralsRoute = AccountReferralsRouteImport.update({
            id: '/account/referrals',path: '/account/referrals',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAdDirectorRoute = AdminAdDirectorRouteImport.update({
            id: '/admin/ad-director',path: '/admin/ad-director',getParentRoute: () => rootRouteImport
          })
const AdminAdStudioRoute = AdminAdStudioRouteImport.update({
            id: '/admin/ad-studio',path: '/admin/ad-studio',getParentRoute: () => rootRouteImport
          })
const AdminAppointmentsRoute = AdminAppointmentsRouteImport.update({
            id: '/admin/appointments',path: '/admin/appointments',getParentRoute: () => rootRouteImport
          })
const AdminAttributionRoute = AdminAttributionRouteImport.update({
            id: '/admin/attribution',path: '/admin/attribution',getParentRoute: () => rootRouteImport
          })
const AdminAudienceLabRoute = AdminAudienceLabRouteImport.update({
            id: '/admin/audience-lab',path: '/admin/audience-lab',getParentRoute: () => rootRouteImport
          })
const AdminCartLinkRoute = AdminCartLinkRouteImport.update({
            id: '/admin/cart-link',path: '/admin/cart-link',getParentRoute: () => rootRouteImport
          })
const AdminCheckoutAttemptsRoute = AdminCheckoutAttemptsRouteImport.update({
            id: '/admin/checkout-attempts',path: '/admin/checkout-attempts',getParentRoute: () => rootRouteImport
          })
const AdminDraftsRoute = AdminDraftsRouteImport.update({
            id: '/admin/drafts',path: '/admin/drafts',getParentRoute: () => rootRouteImport
          })
const AdminEmailHealthRoute = AdminEmailHealthRouteImport.update({
            id: '/admin/email-health',path: '/admin/email-health',getParentRoute: () => rootRouteImport
          })
const AdminEmailLogRoute = AdminEmailLogRouteImport.update({
            id: '/admin/email-log',path: '/admin/email-log',getParentRoute: () => rootRouteImport
          })
const AdminExperimentsRoute = AdminExperimentsRouteImport.update({
            id: '/admin/experiments',path: '/admin/experiments',getParentRoute: () => rootRouteImport
          })
const AdminFranchiseLeadsRoute = AdminFranchiseLeadsRouteImport.update({
            id: '/admin/franchise-leads',path: '/admin/franchise-leads',getParentRoute: () => rootRouteImport
          })
const AdminIndexingRoute = AdminIndexingRouteImport.update({
            id: '/admin/indexing',path: '/admin/indexing',getParentRoute: () => rootRouteImport
          })
const AdminLengthSettingsRoute = AdminLengthSettingsRouteImport.update({
            id: '/admin/length-settings',path: '/admin/length-settings',getParentRoute: () => rootRouteImport
          })
const AdminLocationContentRoute = AdminLocationContentRouteImport.update({
            id: '/admin/location-content',path: '/admin/location-content',getParentRoute: () => rootRouteImport
          })
const AdminLocationHeroVideoRoute = AdminLocationHeroVideoRouteImport.update({
            id: '/admin/location-hero-video',path: '/admin/location-hero-video',getParentRoute: () => rootRouteImport
          })
const AdminLocationHeroesRoute = AdminLocationHeroesRouteImport.update({
            id: '/admin/location-heroes',path: '/admin/location-heroes',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminMaintenanceRoute = AdminMaintenanceRouteImport.update({
            id: '/admin/maintenance',path: '/admin/maintenance',getParentRoute: () => rootRouteImport
          })
const AdminMarketingAiRoute = AdminMarketingAiRouteImport.update({
            id: '/admin/marketing-ai',path: '/admin/marketing-ai',getParentRoute: () => rootRouteImport
          })
const AdminPageLayoutsRoute = AdminPageLayoutsRouteImport.update({
            id: '/admin/page-layouts',path: '/admin/page-layouts',getParentRoute: () => rootRouteImport
          })
const AdminPromoCodesRoute = AdminPromoCodesRouteImport.update({
            id: '/admin/promo-codes',path: '/admin/promo-codes',getParentRoute: () => rootRouteImport
          })
const AdminReferralsRoute = AdminReferralsRouteImport.update({
            id: '/admin/referrals',path: '/admin/referrals',getParentRoute: () => rootRouteImport
          })
const AdminResetPasswordRoute = AdminResetPasswordRouteImport.update({
            id: '/admin/reset-password',path: '/admin/reset-password',getParentRoute: () => rootRouteImport
          })
const AdminRestorationPreviewsRoute = AdminRestorationPreviewsRouteImport.update({
            id: '/admin/restoration-previews',path: '/admin/restoration-previews',getParentRoute: () => rootRouteImport
          })
const AdminStateRulesRoute = AdminStateRulesRouteImport.update({
            id: '/admin/state-rules',path: '/admin/state-rules',getParentRoute: () => rootRouteImport
          })
const PublisherIndexRoute = PublisherIndexRouteImport.update({
            id: '/publisher/',path: '/publisher/',getParentRoute: () => rootRouteImport
          })
const PublisherIdRoute = PublisherIdRouteImport.update({
            id: '/publisher/$id',path: '/publisher/$id',getParentRoute: () => rootRouteImport
          })
const PublisherLoginRoute = PublisherLoginRouteImport.update({
            id: '/publisher/login',path: '/publisher/login',getParentRoute: () => rootRouteImport
          })
const PublisherNewRoute = PublisherNewRouteImport.update({
            id: '/publisher/new',path: '/publisher/new',getParentRoute: () => rootRouteImport
          })
const PublisherSetPasswordRoute = PublisherSetPasswordRouteImport.update({
            id: '/publisher/set-password',path: '/publisher/set-password',getParentRoute: () => rootRouteImport
          })
const PublicFranchiseStateRoute = PublicFranchiseStateRouteImport.update({
            id: '/franchise/$state',path: '/franchise/$state',getParentRoute: () => PublicRoute
          })
const PublicFranchiseWashingtonRoute = PublicFranchiseWashingtonRouteImport.update({
            id: '/franchise/washington',path: '/franchise/washington',getParentRoute: () => PublicRoute
          })
const PublicLearnIndexRoute = PublicLearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => PublicRoute
          })
const PublicLearnSlugRoute = PublicLearnSlugRouteImport.update({
            id: '/learn/$slug',path: '/learn/$slug',getParentRoute: () => PublicRoute
          })
const PublicLocationsIndexRoute = PublicLocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => PublicRoute
          })
const PublicLocationsSlugRoute = PublicLocationsSlugRouteImport.update({
            id: '/locations/$slug',path: '/locations/$slug',getParentRoute: () => PublicRoute
          })
const PublicOrderIndexRoute = PublicOrderIndexRouteImport.update({
            id: '/order/',path: '/order/',getParentRoute: () => PublicRoute
          })
const PublicOrderSuccessRoute = PublicOrderSuccessRouteImport.update({
            id: '/order/success',path: '/order/success',getParentRoute: () => PublicRoute
          })
const PublicPayBalanceTokenRoute = PublicPayBalanceTokenRouteImport.update({
            id: '/pay-balance/$token',path: '/pay-balance/$token',getParentRoute: () => PublicRoute
          })
const PublicServicesDeerFenceRoute = PublicServicesDeerFenceRouteImport.update({
            id: '/services/deer-fence',path: '/services/deer-fence',getParentRoute: () => PublicRoute
          })
const PublicServicesDogFenceRoute = PublicServicesDogFenceRouteImport.update({
            id: '/services/dog-fence',path: '/services/dog-fence',getParentRoute: () => PublicRoute
          })
const PublicServicesFenceRestorationRoute = PublicServicesFenceRestorationRouteImport.update({
            id: '/services/fence-restoration',path: '/services/fence-restoration',getParentRoute: () => PublicRoute
          })
const PublicServicesGardenFenceRoute = PublicServicesGardenFenceRouteImport.update({
            id: '/services/garden-fence',path: '/services/garden-fence',getParentRoute: () => PublicRoute
          })
const AdminContentIndexRoute = AdminContentIndexRouteImport.update({
            id: '/admin/content/',path: '/admin/content/',getParentRoute: () => rootRouteImport
          })
const AdminContentIdRoute = AdminContentIdRouteImport.update({
            id: '/admin/content/$id',path: '/admin/content/$id',getParentRoute: () => rootRouteImport
          })
const AdminContentNewRoute = AdminContentNewRouteImport.update({
            id: '/admin/content/new',path: '/admin/content/new',getParentRoute: () => rootRouteImport
          })
const AdminLeadsIndexRoute = AdminLeadsIndexRouteImport.update({
            id: '/admin/leads/',path: '/admin/leads/',getParentRoute: () => rootRouteImport
          })
const AdminMediaSubmissionsIndexRoute = AdminMediaSubmissionsIndexRouteImport.update({
            id: '/admin/media-submissions/',path: '/admin/media-submissions/',getParentRoute: () => rootRouteImport
          })
const AdminMediaSubmissionsIdRoute = AdminMediaSubmissionsIdRouteImport.update({
            id: '/admin/media-submissions/$id',path: '/admin/media-submissions/$id',getParentRoute: () => rootRouteImport
          })
const AdminOrdersIndexRoute = AdminOrdersIndexRouteImport.update({
            id: '/admin/orders/',path: '/admin/orders/',getParentRoute: () => rootRouteImport
          })
const AdminOrdersIdRoute = AdminOrdersIdRouteImport.update({
            id: '/admin/orders/$id',path: '/admin/orders/$id',getParentRoute: () => rootRouteImport
          })
const AdminPhotosIndexRoute = AdminPhotosIndexRouteImport.update({
            id: '/admin/photos/',path: '/admin/photos/',getParentRoute: () => rootRouteImport
          })
const AdminPhotosDuplicatesRoute = AdminPhotosDuplicatesRouteImport.update({
            id: '/admin/photos/duplicates',path: '/admin/photos/duplicates',getParentRoute: () => rootRouteImport
          })
const AdminPhotosLibraryRoute = AdminPhotosLibraryRouteImport.update({
            id: '/admin/photos/library',path: '/admin/photos/library',getParentRoute: () => rootRouteImport
          })
const PublicLocationsABRoute = PublicLocationsABRouteImport.update({
            id: '/locations/$a/$b',path: '/locations/$a/$b',getParentRoute: () => PublicRoute
          })
const AdminLeadsKindIdRoute = AdminLeadsKindIdRouteImport.update({
            id: '/admin/leads/$kind/$id',path: '/admin/leads/$kind/$id',getParentRoute: () => rootRouteImport
          })
const AdminPhotosReviewIndexRoute = AdminPhotosReviewIndexRouteImport.update({
            id: '/admin/photos/review/',path: '/admin/photos/review/',getParentRoute: () => rootRouteImport
          })
const AdminPhotosReviewIdRoute = AdminPhotosReviewIdRouteImport.update({
            id: '/admin/photos/review/$id',path: '/admin/photos/review/$id',getParentRoute: () => rootRouteImport
          })
const PublicLocationsStateSlugTownSlugServiceSlugRoute = PublicLocationsStateSlugTownSlugServiceSlugRouteImport.update({
            id: '/locations/$stateSlug/$townSlug/$serviceSlug',path: '/locations/$stateSlug/$townSlug/$serviceSlug',getParentRoute: () => PublicRoute
          })





const PublicRouteChildren = {
  PublicSplatRoute: PublicSplatRoute,PublicAboutRoute: PublicAboutRoute,PublicBeatMyEstimateRoute: PublicBeatMyEstimateRoute,PublicBookRoute: PublicBookRoute,PublicContactRoute: PublicContactRoute,PublicCookiesRoute: PublicCookiesRoute,PublicFenceTuneupRoute: PublicFenceTuneupRoute,PublicFinancingRoute: PublicFinancingRoute,PublicFranchiseOpportunitiesRoute: PublicFranchiseOpportunitiesRoute,PublicGalleryRoute: PublicGalleryRoute,PublicNeighborsRoute: PublicNeighborsRoute,PublicPrivacyRoute: PublicPrivacyRoute,PublicReferRoute: PublicReferRoute,PublicRestorationPreviewRoute: PublicRestorationPreviewRoute,PublicShareYourFenceRoute: PublicShareYourFenceRoute,PublicTermsRoute: PublicTermsRoute,PublicThanksRoute: PublicThanksRoute,PublicIndexRoute: PublicIndexRoute,PublicFranchiseStateRoute: PublicFranchiseStateRoute,PublicFranchiseWashingtonRoute: PublicFranchiseWashingtonRoute,PublicLearnSlugRoute: PublicLearnSlugRoute,PublicLocationsSlugRoute: PublicLocationsSlugRoute,PublicOrderSuccessRoute: PublicOrderSuccessRoute,PublicPayBalanceTokenRoute: PublicPayBalanceTokenRoute,PublicServicesDeerFenceRoute: PublicServicesDeerFenceRoute,PublicServicesDogFenceRoute: PublicServicesDogFenceRoute,PublicServicesFenceRestorationRoute: PublicServicesFenceRestorationRoute,PublicServicesGardenFenceRoute: PublicServicesGardenFenceRoute,PublicLearnIndexRoute: PublicLearnIndexRoute,PublicLocationsIndexRoute: PublicLocationsIndexRoute,PublicOrderIndexRoute: PublicOrderIndexRoute,PublicLocationsABRoute: PublicLocationsABRoute,PublicLocationsStateSlugTownSlugServiceSlugRoute: PublicLocationsStateSlugTownSlugServiceSlugRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,AuthRoute: AuthRoute,AccountMaintenanceRoute: AccountMaintenanceRoute,AccountOrdersRoute: AccountOrdersRoute,AccountReferralsRoute: AccountReferralsRoute,AdminAdDirectorRoute: AdminAdDirectorRoute,AdminAdStudioRoute: AdminAdStudioRoute,AdminAppointmentsRoute: AdminAppointmentsRoute,AdminAttributionRoute: AdminAttributionRoute,AdminAudienceLabRoute: AdminAudienceLabRoute,AdminCartLinkRoute: AdminCartLinkRoute,AdminCheckoutAttemptsRoute: AdminCheckoutAttemptsRoute,AdminDraftsRoute: AdminDraftsRoute,AdminEmailHealthRoute: AdminEmailHealthRoute,AdminEmailLogRoute: AdminEmailLogRoute,AdminExperimentsRoute: AdminExperimentsRoute,AdminFranchiseLeadsRoute: AdminFranchiseLeadsRoute,AdminIndexingRoute: AdminIndexingRoute,AdminLengthSettingsRoute: AdminLengthSettingsRoute,AdminLocationContentRoute: AdminLocationContentRoute,AdminLocationHeroVideoRoute: AdminLocationHeroVideoRoute,AdminLocationHeroesRoute: AdminLocationHeroesRoute,AdminLoginRoute: AdminLoginRoute,AdminMaintenanceRoute: AdminMaintenanceRoute,AdminMarketingAiRoute: AdminMarketingAiRoute,AdminPageLayoutsRoute: AdminPageLayoutsRoute,AdminPromoCodesRoute: AdminPromoCodesRoute,AdminReferralsRoute: AdminReferralsRoute,AdminResetPasswordRoute: AdminResetPasswordRoute,AdminRestorationPreviewsRoute: AdminRestorationPreviewsRoute,AdminStateRulesRoute: AdminStateRulesRoute,PublisherIdRoute: PublisherIdRoute,PublisherLoginRoute: PublisherLoginRoute,PublisherNewRoute: PublisherNewRoute,PublisherSetPasswordRoute: PublisherSetPasswordRoute,AccountIndexRoute: AccountIndexRoute,AdminIndexRoute: AdminIndexRoute,PublisherIndexRoute: PublisherIndexRoute,AdminContentIdRoute: AdminContentIdRoute,AdminContentNewRoute: AdminContentNewRoute,AdminMediaSubmissionsIdRoute: AdminMediaSubmissionsIdRoute,AdminOrdersIdRoute: AdminOrdersIdRoute,AdminPhotosDuplicatesRoute: AdminPhotosDuplicatesRoute,AdminPhotosLibraryRoute: AdminPhotosLibraryRoute,AdminContentIndexRoute: AdminContentIndexRoute,AdminLeadsIndexRoute: AdminLeadsIndexRoute,AdminMediaSubmissionsIndexRoute: AdminMediaSubmissionsIndexRoute,AdminOrdersIndexRoute: AdminOrdersIndexRoute,AdminPhotosIndexRoute: AdminPhotosIndexRoute,AdminLeadsKindIdRoute: AdminLeadsKindIdRoute,AdminPhotosReviewIdRoute: AdminPhotosReviewIdRoute,AdminPhotosReviewIndexRoute: AdminPhotosReviewIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)